export enum Quadrant {
  UPPER_RIGHT = 101,
  UPPER_LEFT = 102,
  LOWER_LEFT = 103,
  LOWER_RIGHT = 104,
}

// Pediatric Quadrants are different from adult quadrants since under the hood we don't store separately, so we need different values to avoid conflicts
export enum PediatricQuadrant {
  UPPER_RIGHT = 201,
  UPPER_LEFT = 202,
  LOWER_LEFT = 203,
  LOWER_RIGHT = 204,
}

export const quadrantAttributes = {
  [Quadrant.UPPER_RIGHT]: {
    initials: 'UR',
    description: 'Upper Right',
    image: 'upper-right.png',
  },
  [Quadrant.UPPER_LEFT]: {
    initials: 'UL',
    description: 'Upper Left',
    image: 'upper-left.png',
  },
  [Quadrant.LOWER_LEFT]: {
    initials: 'LL',
    description: 'Lower Left',
    image: 'lower-left.png',
  },
  [Quadrant.LOWER_RIGHT]: {
    initials: 'LR',
    description: 'Lower Right',
    image: 'lower-right.png',
  },
  [PediatricQuadrant.UPPER_RIGHT]: {
    initials: 'UR',
    description: 'Upper Right',
    image: 'upper-right.png',
  },
  [PediatricQuadrant.UPPER_LEFT]: {
    initials: 'UL',
    description: 'Upper Left',
    image: 'upper-left.png',
  },
  [PediatricQuadrant.LOWER_LEFT]: {
    initials: 'LL',
    description: 'Lower Left',
    image: 'lower-left.png',
  },
  [PediatricQuadrant.LOWER_RIGHT]: {
    initials: 'LR',
    description: 'Lower Right',
    image: 'lower-right.png',
  },
};
